// extracted by mini-css-extract-plugin
export default {"error":"ServerErrorPage_error__y9Xdj"};